/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Suspense, useEffect, useState } from "react";
import ct from "class-types.macro";
import ReactDOM from "react-dom";
import CheckHttpStatus from "fetch-check-http-status";
import { logErrorMessage } from "@wss/error-tracking";
import Modal, { Body, Header } from "~/common/ModalReact";
import useIsMounted from "~/common/useIsMounted";
import { valid } from "~/common/Email/EmailValidator";
interface Props {
  emailAddress: string;
  itemNumber: string;
}
const NotifyMeButton = ({
  emailAddress,
  itemNumber
}: Props) => {
  const isMounted = useIsMounted();
  const [email, setEmail] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [notifyRequested, setNotifyRequested] = useState(false);
  const [showError, setShowError] = useState(false);
  const [noEmailError, setNoEmailError] = useState(false);
  useEffect(() => {
    setEmail(String(emailAddress));
  }, [emailAddress]);
  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = String(event.target.value);
    setShowError(false);
    setNoEmailError(false);
    setEmail(newEmail);
  };
  const clearForm = () => {
    setShowError(false);
    setNoEmailError(false);
    setNotifyRequested(false);
    setEmail("");
  };
  const handleRequestNotification = async (event: React.SyntheticEvent) => {
    event.preventDefault();
    if (!email) {
      return setNoEmailError(true);
    }
    if (!valid({
      emailAddress: email
    })) {
      return setShowError(true);
    }
    const apiUrl = "/api/customers/notifications/productavailability/add";
    const request = {
      itemnumber: itemNumber,
      email
    };
    await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(request)
    }).then(CheckHttpStatus).catch(error => {
      logErrorMessage(error, "info");
      return setShowError(true);
    });
    if (!showError) {
      const {
        emailSignupEvent
      } = await import("~/gtm");
      emailSignupEvent(email);
      return setNotifyRequested(true);
    }
    return setNotifyRequested(false);
  };
  return <>
      {isMounted && ReactDOM.createPortal(<Suspense fallback={null}>
            <Modal isOpen={openModal} onRequestClose={() => {
        clearForm();
        setOpenModal(false);
      }} className={`${ct("md:max-w-sm")}`}>
              <Header closeModal={() => {
          clearForm();
          setOpenModal(false);
        }}>
                <h3 className={`${ct("flex", "text-base", "m-0", "md:text-xl")}`}>
                  Notify Me
                </h3>
              </Header>
              <Body>
                {notifyRequested ? <p className="mapText thanksText" data-testid="notify-success-message" style={{
            fontSize: "14px",
            textAlign: "center"
          }}>
                    We will notify you when this product is available. To make
                    sure you receive our email, please add&nbsp;
                    <a>
                      <strong>help@webstaurantstore.com</strong>
                    </a>
                    &nbsp;to your address book.
                  </p> : <div id="unavailableContainer">
                    Notify me when this product is back in stock.
                    <form action="#" method="POST" className="form" onSubmit={handleRequestNotification} style={{
              marginTop: "20px"
            }}>
                      <div className="form__append-container">
                        <div className="form__control-container">
                          <input type="text" className="form__control form__append" placeholder="Email" name="email" maxLength={100} onChange={handleEmailChange} value={email} data-testid="carousel-out-of-stock-notify-email" />
                          <label className="form__label">Email</label>
                        </div>
                        <div className="form__control-container form__control-container--append">
                          <button type="submit" className={`btn btn-info form__append ${ct("h-full", "m-0")}`} onClick={handleRequestNotification} data-testid="carousel-out-of-stock-notify-submit">
                            Submit
                          </button>
                        </div>
                      </div>

                      {(noEmailError || showError) && <div className="form__error" data-testid="carousel-out-of-stock-error">
                          {showError && <>
                              Error sending email address.
                              <br />
                              Please try again or email{" "}
                              <a href="mailto:help@webstaurantstore.com">
                                <strong>help@webstaurantstore.com</strong>
                              </a>
                            </>}
                          {noEmailError && "Please enter an email address"}
                        </div>}
                    </form>
                  </div>}
              </Body>
            </Modal>
          </Suspense>, document.querySelector("body") as Element)}
      <div className="add-to-cart">
        <div className="btn-container">
          <span className="pricing">
            <span className="price small">Out Of Stock</span>
          </span>
          <button type="button" className="btn btn-cart btn-small notify-popover" onClick={() => setOpenModal(true)} data-testid="carousel-notify-me-button">
            Notify Me
          </button>
        </div>
      </div>
    </>;
};
export default NotifyMeButton;